import React, { useEffect, useState, Fragment } from "react";
import "./Navbar.css";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Disclosure, Menu, Popover, Transition } from "@headlessui/react";
import axios from 'axios';
import ReactDOM from 'react-dom';
import { useNavigate , useParams } from 'react-router-dom';
import {  MagnifyingGlassIcon,  Bars3Icon,  ShoppingCartIcon, XMarkIcon,  ArrowPathIcon,  ChevronDownIcon,} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import ProductCard from "../../user/COMPONENTS/Product/ProductCard";
// const india = [{ name: "CAD", href: "#" }];
const user = {
  name: "ram",
  email: "ram@example.com",
  imageUrl:
    "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAMAAzAMBIgACEQEDEQH/xAAcAAEAAgIDAQAAAAAAAAAAAAAABwgBBgMEBQL/xABGEAABAwMBAwkEBwUGBgMAAAABAAIDBAURBgchMRITIkFRYXGBkUKhscEUIzJSYnKSFlOCwtEVJDNDVWNzg6Ky4fAlNFT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AnFERAREQEREBEXHLIyFrnyOaxjd7nOdgBByItC1FtTsNqJiozJcZwcEU/wBlp73Hd6ZUfXnarqWvL2UUkFtiPDmWB7/1OyPQBBPhcAMk4A4k9S6VRerVTZFRcqSMjqdO0H4qs09feb5KBPU3G4u4cnlPl9w3D0XbpdGajqgHQ2SrLTwLmhvxKCwL9YacYcOvVEP+aFyxansMxxHeKE/89o+agZuznVbhkWhw/NI0fNcc2z/VUYybJM4DjyXNPzQWOgqYKkZp54pR2xvDvguUKrNRZbzbHB81ur6ct9sRPAHmOC71r1vqa2PH0S9VLg3cYpyJmeB5QJ9CEFmUUPWTbI8Fsd+t2RwM9GeHeWO+RKkqx6ktF+i5drro5iOLM4ePFvFB66LA4BZQEREBERAREQEREBERAXy44RxAG/h1nsUR7QNpp+utWmpcFpLJq5u8Z4Fsfb4oNr1ntBtmmg+nZ/fLjjo08btzfzu9lQxqHVd91PU4raiQsccR0kGRGOzDeJPjlNMaUu2qqtzaJhbGXfXVc5Ja0954uPd8FOGktDWjTMQdBEaitIHLqphlxPcODR3BBFWnNl18u4ZNW8m20x3gyjLyO5n9SpFsuyzTNtZmqp33KT71Zhzf0ABvuW9Ig69LR01HG2Olp4oWN3BsbA0D0XYREBERB8uAcMEZXi3fSlhvIzcLXSyv6pOb5L2+DhvC9xEETX3Y1CQ+SwXB8buIgq+m3wDxvHnlRvdbLe9L1bH1tNPRytPQmjccE9zwrQrr1tHT10D6ergZNC8Ycx4yCghzSG1ispCyk1K01NNjAq2D61n5h7Q7xv8AFTBbq+kuVHHV0M7J6eQZbIw5BUT602UPi5yu0uXPZkufQvOSP+GT/wBp8j1LSNM6ku2kbg80hcGB+J6SXIDz1gjqPeEFmkXg6S1Rb9UW8VVA8tezozU7yOXC7sP9eBXu5BQZREQEREBERAWHcEPBR5tZ1g6yUAtduk5Nxq29J7Tvhi39LxPAeZQa/tV166V81hs0uIhllXOwkFx62NPxPktd0BoOo1ROJ6oPp7VEcOkacOlI9lvzPV1b10tA6Sk1TdRC4PZQU+DVSDs+6PxH3cVYuhpIaGkipaWNscETQ1jGjc0BB826gpbbRx0lDBHBTxNwxkYwAuyOCyiAiLr19dS26imrK6ZkFNC0ukkecBoQc+QvDverrBYjyLpdIIpf3Tcvk/S3JUR602m3G8OkpbK6ShoM4EjTiSUduR9keG9R+AAXEAZccnvPb4oJ7m2uaWY7ksdXSj7zKfA95C7VFtR0lVODXXF1M4//AKIXMA8XYwPVV7z3JnfwQWxpKunrIGz0k8U8LxlskTw5pHiFzA5VWLFerjp+q+k2ipdTvJy9g+xJ+ZvA/FTnoDX1JqdhpKhraa5sbyjFndK0cXN/og3VERBghaNtA2f0upI3VlC1lPdmt6MgGGzfhf8AI9XuW9LBCCr1ruF10jfedhD6espzyJoJNwcOtru0d/hhWH0pqKj1Nao6+jJB+zLEftRv6wVrm07RDdQ0Jr7exrbrTMyP99g9g9/YVEmi9T1OlL22qHK+juIjq4Du5Te3HU5vH1CCzAIKyuCjqYaymiqaaQSQysD2PbwIPBc6AiIgIiIOhe7nT2e1VVwqziGnjL3d+Or4KtdVPX6r1E55HOVtfNhjOzPAeAHwKkPbjfzzlHYKeQckAVFVg/ob8T5BY2IadbJLUahqY9zMwUgd/wBb/wCX9XagknSthp9O2aC30wB5AzI8je954kr1xuQBZQEREGCcKB9reqnXm7m1UsmaCjf0scJJR1ntA4Dv3qYNX3T+xtN3GvBw+GFxZnrcdw95CrASXO5TyXOJy4niSgdmUREBERAXJTzzUtRFU00r4poXiSN7DgtcN4K406t245QWX0PqSPUthhrcBs7ehOwH7Lxx9eK2FQVsTuzqXUlRbHOPNVkJc1pPB7ezyJ9FOg4bkGUREGCoT2yaVbb6xt9oYsU9S/k1AaNzJOp3n8fFTauhe7XTXm01durW8qGpjLHY4jsI7wd4QRlsV1OMy6eq5M8kGSkz2e035+qlvKqyRX6Y1AcEsr7dU7t+OWWn/tcPc5WbtFwhutspbhSnMNTE2Rvdnq8uCDuIiIC+XuDGOc44a0ZJ7Avpa9r64m16QudUHcl/MljPzO3D4oK/6kr5b/qasqmDMlTUlkQO/IyGtHphWO03a47LY6K3QjDYIWsPaT1k+eVAey+2i461t0bvsU5MxyM5DR/XCscEGUREBERBoe2qRzNCTtacc5UwNJ7ucB+SgNWK2rULrhoS5xsBL4mtnAA3nkODvkq68eCAiIgIiICIiDYNnkroteWEszl1SWnwMbwVZgKu2yehdW67t7wDyKQSTu/SWj3v9ysQOG5BlERAWDwWUQQntvswprvSXaFuBVs5qQj77d4PjjI8lsexC6mosFRbHuBdRSksGfYdv+OfVettbtor9FVjx9ulLZ2nwO/3EqNdjVf9D1j9GJwyrhczHa4bx80E+BZWAsoCjrbhOGaRipyf8erjHjyel8lIqinb28i32ePPGpe70Yf6oPL2DU3OXm61ZH+DTMjGfxOJ/kU04woo2Bt/ut7k/wB6Jvo1x+alhAREQEREHFUQsqIZIJRmORpa4doPFVh1TZJ9PX2pt07dzXExOxucw/ZI8tytGtQ2h6Oi1VbcxFsVygBNPMeB7WO7j7kFdkXPX0dVbqyWiroHQ1UJxJG/iP6jvC4EBERAQce3uTzxhbvs60LPqKpjra+NzLRG7fyhg1BHst7u0oN22LaffQWma8VLC2atwIgRgiIcPU5KkocF8QsZHEyOJgYxgDWtA3ADqXIgIiICIiDpXqlFdZ66kIyJ6d8fq0hVq0VVfRNV2Wc5HJqWA+fR/mVolVOn/u98hPDma9v/AEyj+iC1YWVhhy0HuWUBRRt7Z/cLM/sqHt9WE/JSuo325wB+laep/cVbN/ZygW/NB5+wJ2KS9s/3onerSPkpYUMbBqnkXW70pOOcgjkA/K4j+YKZ0BERAREQEWMhfEsscLC+V7WMHFznABB4+pNL2rUtOIrnTBz2jEc7OjJH4H5KL71seuULnOstZDUx56Mc/QcPMblKFVq/TtI4tqLzRMcOrnQV1v290p/rlJ+tBC0mznVsbiDaXPI62ytI+K7dBss1TVyt5+ngpWHi6WbJHkOPqpe/b3Sn+uUn60/b3Sn+uUn60Guab2TWu3vZPeJP7QmbvEfJ5MWe8cT5qRYmNjYGMaGtaMBrRgAdy15uu9LP4XyjHjJhetQ3i23DH0GvppyeqOQE+iDvIsZ7UyEGUREBERAVU4jzt8YRv52vB3d8v/lWiulSKO21dU4gCGF8hJ7mkqsuj6Y1ep7PA4ZL6lhPfjpfyoLRM3MA7l9LAWUBaztHt5uWjLnA1uXsi51n5m7/AJLZl8TRtlhfE8ZY9pa4dx4oK8bKLiKHW1CXHDKproD/ABDI94ViRx+Sq5dqafT2paiCMHnaGqJZ5HLfdj1VlrLcIrraqSvgOY6iJrx5hB3kRYygZXWuFfS26lkqq6oZBAwZL3nAC69/vFHYrbNcLhJyIIh1cXHqaB1kqvGr9V1+qa8zVZMdKwkQ0rXdFg7+13eg3PVW12plkdT6ZgbFEMg1c7cud+RnAeLs+Cjq5Xe5XWUyXGuqKhx65JDj04LpIgYA4bvBERAREQFljiw8qNz2HtacH3LCINpsW0HUllcxsdZ9Lp28aeq6QI7A7i3x9yl/R2v7VqYCEA0dfjfTTEEnvafaHvVd1ljnMkbIxzmvYctc04LT3ILa8oAdi+lGGzHaA66GOzXyQGuDcU85/wA8Dqd1cr4qTh4IMoiINR2qXFtv0RcMuw6oAgb/ABHB92VFex+3ms1pDNjoUcTpfAkYHxK97bjdxLV0VnY4FsQ5+cdhO5vzXp7DLUYrVW3WQYNTJzUZ7Ws4+/PoglALKwsoCweCyiCFtuFidBcqS+QM+pqG8zUuHVI0dE+bcj+EL0th+oucpqrT9S/pwkzUoJ4xn7QHgTnwd3KQtTWWG/2OrtlRubMzDXdbHDg4d4KrhTTV+ldRNlwY623z9Jp3crqI8CM+qC0YOUdw3cV0LDdqa92qnuNG7MUzc462nrB7wV4e029Psukqp8Dy2oqBzERHEF3EjyygiTaZqx2o73JBSyZtlI4sg5J3SOG5z/XIHdv61pyw0ANAbjAG7HBZQEREBERAREQEREBERB9RvdHI2SN7mPaQ5jmnBa4cCFYnZxqn9p7AHzEfTqZ3NVLR2+y7wcN/r2Kui3DZTeTZ9WwMc/EFb/d5B1ZO9p9fiUFiF1rhXQW+hqKyrdyIKeMySO7ABldg8FEG2nVAkDdO0T84IkqyD5tZ8/RBHF0rK3U+oJqhrHPqq6fEMXicMb5DGfMqy2n7XDZLNSW2n3sp4g3lfePWfM5Pmoo2LaZNTXPv9U081Tl0dMHDi/2neW8eamcDCDKIiAiIgweCi7bHpB1bTftBboi6pp2BtVG0b5Ix7Q7S34eClJYcAQQRkHcQUFe9mmsv2ZuHMVT+VaqtwEnXzLvvju7fAKcLzbLfqK0SUlYxs1NO3LXA8N257T71Du0/QrrJPJdrVEf7MkdmVjeFMT3fdPu8FnZxtBfZHMtl4kLra4gRSkZNMe/8Hw8OAazq7S1w0tcHwVjTJTOcfo9SB0ZB8nd3mF4Z3FWkudutuobWaWshiqqOYZBznwc09R7CFCOs9nVx0+91TQNfW23jy2jpxjscOzvHuQaSiwDkZG9ZQEREBERAREQERdu02ytvFayjttO+ondxa0fZHaT1BB1QCSA0FxJwABkk9g7VM2zDQBthjvN7jH0074ICP8AfeP4j7l6GhNnNLYjHX3TkVVyA6IxmOA93afxei9bW2sqDStH0+TNXSD6mmB4ntd2N70HHtB1jFpe2YhLJLlUAiniJ4fjd3D3qDtO2Wu1Xfm0kcj5Jpn8upqHjPIbnpPPeertK+JJbtq2/jlcuquNW/otG4ADqH3WgKfdC6UpNLWvmIwJKubDqmoxveewfhHUEHtWq309roIKGjZyIIGBrG/M967ixgBZQEREBERAREQcc8Uc0T4pWNfG8FrmuAIIPUVCOvtms1pdJcLBG+a3npPp97nwduOst7upTksEdvBBXTRWvLjpcth/+3bScupi7e0drD1Hu4HuU46c1JadTUhmttU2Q4HLidufH3OaeC1TW2zCjvDpa2yllHcHZLmEfUynvHsnvHoVEVbQ3rStzaKllRb6pn2ZGkgEdocNzggmjVOzGzXx7qqk5VtrHbzJCMsefxM4eYwe3KjC/bN9R2jlObSith/eUvS3dpad4Xv6d2v1tJyIb/SfTI+AmgAbKPEHc73KSLJrbT17w2huUXPEf4Ep5t/6XYQVslY+CQx1DHRyfce3kkeq+VaqstlvuLMVlHT1DDx5yMOyFr1Ts10nU5/8AiY4STn6h7mfAoK7Ip7fsk0q45ENY3wqn/wBVyw7KtKQuDjSTyY6n1Dz80FfnENHSwO8lelbLFd7s4MttuqZ8+02M8n1O5WIt2jdOW13Lo7PSMf8AfMYJ9SvTqqygtkJfVVEFLC0ZJe4MaEETae2O1Ermy6hrhDHnfT0py93cXHcPIE96lG0Wi2WChFPbqaKmhYMuI4nvc47z4labfdrljouXFamS3KYbuU0FkQP5jx8gfFRfqXW181C7mqypENO7hTU4LWH35PmgkjWm1OloBJRadLKqqBLX1PGOI933j7u1RXQUN41Zensh52srZzypZXnc0drjwA4/ILYtI7M7tfObqLgDbrcely3j62QfhaeHifQqa7BYbdp+ibR2umbFH7TuLnntceJKDydD6ModJ0vQPP18w+vqXDefwtHst/8ATlbXhEQEREBERAREQEREBERAXUuNBSXKnfTV9NHUQuG9kjchdtEEW6h2PUVSTLYas0T85MMzTJGfA5yPf4KPL1oDUtrDhVWd9TCP82l+vafIdIeYVlV847uPFBV2ivt9tDhHTXKupSz2HPO7+F3wXu0u1DVVOA01sU2P3sIOfRT5WW2hrm8mto6eoB/exNd8V41ToPS9SSZLLTAn7gLfggilu1zUuN7KJx7eax81xSbWdUPBDZKNneIOHvUnP2ZaTcci2lv5ZXD5rli2caUiIP8AZMb/AM73H5oIWrtfanrWlsl4njb92INaD7srzILdeb/Uh8VFX3Gb2X82+TH8R3N8yFY+k0tYqMg01nomEcDzLSfevXa0MaGsaGtHAAYQQXZNkd8rgx92mgt0R3lg+tkx5dEHzKk3Teg7Dp/kyU1Jz1SP8+o6bvLO4eS2kIgIiICIiAiIgIiIP//Z",
};
const navigation = [{ name: "Become Supplier", href: "#" }];
function classNames(...classes) {
    return classes.filter(Boolean).join(" ");}
const Navbar = ({categoryId, children, reloadnavbar, onSearch }) => {
  const navigate = useNavigate();
  const { pk } = useParams();
  const [products, setProducts] = useState([]);
  const [query, setQuery] = useState(""); // State to store the search query
  // const [response, setresponse] = useState({});
  const [openMenus, setOpenMenus] = useState({})
  const userNavigation = [
    { name: "My Profile", link: `/user/UserProfile/${pk}` },
    { name: "Orders", link: `/user/yourorders/${pk}` },  
    { name: "Sign out",link: `/logout/${pk}`},
  ];
  
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState({});


    useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://terracharms.com/get_category/");
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubCategories = async (categoryId) => {
    try {
      const response = await axios.get(
        `https://terracharms.com/get_sub_categories_by_cat/${categoryId}/`
      );
      console.log(response.data)
      setSubCategories((prevState) => ({
        ...prevState,
        [categoryId]: response.data,
      }));
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };
  const handleMenuClick = async (categoryId) => {
    setOpenMenus((prevState) => {
      // Close all other categories and only open the currently clicked one
      const newOpenMenus = Object.keys(prevState).reduce((acc, key) => {
        acc[key] = false;  // Set all to false
        return acc;
      }, {});
      
      return {
        ...newOpenMenus,
        [categoryId]: !prevState[categoryId], // Toggle the clicked category
      };
    });
  
    if (!subCategories[categoryId]) {
      await fetchSubCategories(categoryId);
    }
  };

  const handleSubcategoryClick = (sub_id) => {
    navigate(`/user/allproduct/${pk}/${sub_id}/`); // navigate to AllProduct page with the subcategory ID
  };


    const [open, setOpen] = useState(false);
    const india = [
      {
        name: 'India',
        href: '#',
        description: 'Country in South Asia',
        flagSrc: 'https://flagicons.lipis.dev/flags/4x3/in.svg',
      },
      {
        name: 'Canada',
        href: '#',
        description: 'Country in North America',
        flagSrc: 'https://flagicons.lipis.dev/flags/4x3/ca.svg',
      },
      // Add more countries as needed
    ];

    const [cartQuantity, setCartQuantity] = useState(0);

    // Fetch the cart quantity when the component mounts or when `pk` changes
    useEffect(() => {
      if (pk) {
        fetchCartQuantity(); // Fetch the cart quantity if `pk` exists
      }
    }, [pk]);
  
    const fetchCartQuantity = () => {
      axios.get(`https://terracharms.com/get_quantity/${pk}/`)
        .then((response) => {
          console.log('Response Data:', response.data);  // Log the response for debugging
          // Ensure the response data is valid
          if (typeof response.data === 'number') {
            setCartQuantity(response.data);  // Set the fetched quantity
          } else {
            setCartQuantity(0);  // Default to 0 if the response is invalid
          }
        })
        .catch((error) => {
          console.error('Error fetching cart quantity:', error);
          setCartQuantity(0);  // Default to 0 in case of an error
        });
    };

    const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    if (onSearch && typeof onSearch === 'function') {
      onSearch(event.target.value);
    }
  };
  const [openSidebar, setOpenSidebar] = useState(false);
  

  

  const toggleSidebar = () => {
setOpenSidebar(!openSidebar);
  };
  return (
    <>
      <nav>
        <div className="h-100">
        <Disclosure as="nav" className="bg-blue-900">
  {({ open }) => (
    <>
      <div className="flex h-24 items-center">
        {/* Logo and Title */}
        <div className="flex items-center">
          <div className="flex-shrink-0 ml-1 mr-2 flex items-center">
            <Link to={`/front/${pk}`}>
            <img
              className="h-20 w-20 mt-2"
              src="https://cdn.dotpe.in/longtail/store-logo/8631177/mvNA0s1i.webp"
              alt="StarMart"
              />
              </Link>
            <span className=" text-2xl sm:text-4xl mt-3 text-white">The StarkMart</span>
          </div>

          {/* Search Bar */}
          <div className="searchbar-container flex items-center mt-3">
            <i className="fas fa-search search-icon"></i>
            <input
              type="search"
              placeholder="Search product..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="ml-2"
            />
          </div>
        </div>

        {/* Navigation Links */}
        <div className="hidden md:flex md:ml-6 md:space-x-8">
          <Link to="/seller">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className={classNames(
                  item.current ? "bg-gray-900 text-white" : "text-gray-300",
                  "rounded-md py-2 w-60 ml-24 font-medium flex justify-center items-center"
                )}
                aria-current={item.current ? "page" : undefined}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-8 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z"
                  />
                </svg>
                {item.name}
              </a>
            ))}
          </Link>
        </div>

        {/* User Profile and Cart */}
        <div className="hidden md:flex items-center">
          <Popover className="relative">
            {({ open }) => (
              <>
                <Popover.Button
                  className="inline-flex items-center text-white gap-x-2 text-sm font-semibold"
                  onClick={() => setOpen(!open)}
                >
                  <img
                    src="https://flagicons.lipis.dev/flags/4x3/in.svg"
                    className="h-8 w-8"
                    alt="India Flag"
                  />
                  <span>India</span>
                  <ChevronDownIcon
                    className={`h-3 w-3 transform transition-transform ${open ? 'rotate-180' : 'rotate-0'}`}
                    aria-hidden="true"
                  />
                </Popover.Button>
                <Transition
                  as={Fragment}
                  show={open}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute z-10 mt-2 bg-white w-56 rounded-md shadow-lg ring-1 ring-black ring-opacity-5">
                    <div className="p-4">
                      {india.map((item) => (
                        <div key={item.name} className="flex items-center gap-x-2 mb-3">
                          <img
                            src={item.flagSrc}
                            alt={`${item.name} Flag`}
                            className="h-6 w-8"
                          />
                          <div>
                            <a href={item.href} className="font-semibold text-gray-900">
                              {item.name}
                            </a>
                            <p className="mt-1 text-gray-600 text-xs">{item.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>

          <div className="cart flex items-center ml-4">
          <span className="qty">{cartQuantity}</span>
            <Link to={`/cart/${pk}`} className="stylenone">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6 hover"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                />
              </svg>
            </Link>
          </div>

          {/* User Menu */}
          <Menu as="div" className="relative ml-3">
            <div>
              <Menu.Button className="flex max-w-xs items-center rounded-full bg-gray-800 text-sm">
                <span className="sr-only">Open user menu</span>
                <img className="h-8 w-8 rounded-full" src={user.imageUrl} alt="" />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="p-4">
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to={`/user/UserProfile/${pk}`}
                        className={classNames(
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm'
                        )}
                      >
                        Your Profile
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to={`/user/yourorders/${pk}`}
                        className={classNames(
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm'
                        )}
                      >
                        Your Orders
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to={`/logout/${pk}`}
                        className={classNames(
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm'
                        )}
                      >
                        Sign out
                      </Link>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>

        {/* Mobile Menu Button */}
        <div className="-mr-2 mt-3 flex md:hidden">
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            onClick={() => setOpenSidebar(!openSidebar)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
      </div>

      {/* Sidebar */}
      <Transition
        as={Fragment}
        show={openSidebar}
        enter="transition-transform ease-in-out duration-300"
        enterFrom="-translate-x-full"
        enterTo="translate-x-0"
        leave="transition-transform ease-in-out duration-300"
        leaveFrom="translate-x-0"
        leaveTo="-translate-x-full"
      >
        <div className="fixed inset-0 z-40 overflow-y-auto bg-gray-800 text-white">
          <div className="flex h-16 items-center justify-between p-4">
            <h2 className="text-lg font-semibold">Menu</h2>
            <button
              type="button"
              className="text-white"
              onClick={() => setOpenSidebar(false)}
            >
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="px-4 py-6">
            <ul>
              {navigation.map((item) => (
                <li key={item.name} className="py-2">

<Link to="/seller">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className={classNames(
                  item.current ? "bg-gray-900 text-white" : "text-gray-300",
                  "rounded-md py-2 w-60 font-medium flex justify-center items-center" 
                )}
                aria-current={item.current ? "page" : undefined}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-8 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z"
                  />
                </svg>
                {item.name}
              </a>
            ))}
          </Link>
                  <Popover className="relative mb-2">
            {({ open }) => (
              <>
                <Popover.Button
                  className="inline-flex ml-12 py-2 items-center text-white gap-x-2 text-sm font-semibold"
                  onClick={() => setOpen(!open)}
                >
                  <img
                    src="https://flagicons.lipis.dev/flags/4x3/in.svg"
                    className="h-8 w-8"
                    alt="India Flag"
                  />
                  <span>India</span>
                  <ChevronDownIcon
                    className={`h-3 w-3 transform transition-transform ${open ? 'rotate-180' : 'rotate-0'}`}
                    aria-hidden="true"
                  />
                </Popover.Button>
                <Transition
                  as={Fragment}
                  show={open}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute z-10 mt-2 bg-white w-56 rounded-md shadow-lg ring-1 ring-black ring-opacity-5">
                    <div className="p-4">
                      {india.map((item) => (
                        <div key={item.name} className="flex items-center gap-x-2 mb-3">
                          <img
                            src={item.flagSrc}
                            alt={`${item.name} Flag`}
                            className="h-6 w-8"
                          />
                          <div>
                            <a href={item.href} className="font-semibold text-gray-900">
                              {item.name}
                            </a>
                            <p className="mt-1 text-gray-600 text-xs">{item.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>
          <span className="qty ml-16 ">{cartQuantity}</span>
            <Link to={`/cart/${pk}`} className="stylenone">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-8 h-8 hover ml-12"
              > 
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                />
              </svg>
            </Link>
            
            <Menu as="div" className="relative ml-12 py-4">
            <div>
              <Menu.Button className="flex max-w-xs items-center rounded-full bg-gray-800 text-sm">
                <img className="h-8 w-8 mr-2 rounded-full" src={user.imageUrl} alt="" />Open User Menu
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="p-4">
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to={`/user/UserProfile/${pk}`}
                        className={classNames(
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm'
                        )}
                      >
                        Your Profile
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to={`/user/yourorders/${pk}`}
                        className={classNames(
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm'
                        )}
                      >
                        Your Orders
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/logout"
                        className={classNames(
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm'
                        )}
                      >
                        Sign out
                      </Link>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Transition>
    </>
  )}
</Disclosure>

        <div className="py-2"></div>
 {/* <header className="bg-white mb-2 ">
      <div className="py-2"></div>
      <div className="flex justify-center items-center">
        {categories.map((category) => (
          <Menu as="div" key={category.id} className="relative inline-block mx-2">
            <Menu.Button
              onClick={() => handleMenuClick(category.id)}
              className="text-black-300 font-bold text-2xl hover:bg-blue-700 hover:text-white py-1 px-3 rounded-md font-large"
            >
              {category.category_name}
              <ChevronDownIcon
                className="ml-1 h-5 w-5 inline"
                aria-hidden="true"
              />
            </Menu.Button>
            <Transition
              show={openMenus[category.id] || false}
              enter="transition duration-100 ease-out"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute left-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                <div className="py-1">
                  {subCategories[category.id]?.map((subCategory) => (
                    <Menu.Item key={subCategory.sub_id}>
                      {({ active }) => (
                        <button
                        onClick={() => handleSubcategoryClick(subCategory.sub_id)} // handle subcategory click
                        className={`block w-full text-left px-4 py-2 text-1xl  ${
                          active ? "bg-gray-100" : "text-gray-700"
                        }`}
                      >
                        {subCategory.sub_category_name}
                      </button>
                      )}
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        ))}
      </div>
    </header>   */}
    <header className="bg-white mb-2">
  <div className="py-2"></div>
  
  {/* Desktop and Tablet Menu */}
  <div className="hidden md:flex justify-center items-center">
    {categories.map((category) => (
      <Menu as="div" key={category.id} className="relative inline-block mx-2">
        <Menu.Button
          onClick={() => handleMenuClick(category.id)}
          className="text-black-300 font-bold text-2xl hover:bg-blue-700 hover:text-white py-1 px-3 rounded-md font-large"
        >
          {category.category_name}
          <ChevronDownIcon
            className="ml-1 h-5 w-5 inline"
            aria-hidden="true"
          />
        </Menu.Button>
        <Transition
          show={openMenus[category.id] || false}
          enter="transition duration-100 ease-out"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition duration-75 ease-out"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute left-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
            <div className="py-1">
              {subCategories[category.id]?.map((subCategory) => (
                <Menu.Item key={subCategory.sub_id}>
                  {({ active }) => (
                    <button
                      onClick={() => handleSubcategoryClick(subCategory.sub_id)} // handle subcategory click
                      className={`block w-full text-left px-4 py-2 text-1xl ${
                        active ? "bg-gray-100" : "text-gray-700"
                      }`}
                    >
                      {subCategory.sub_category_name}
                    </button>
                  )}
                </Menu.Item>
              ))}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    ))}
  </div>
  
  {/* Mobile Menu */}
   <div className="md:hidden flex flex-col items-center">
    {categories.map((category) => (
      <Menu as="div" key={category.id} className="relative w-full text-center">
        <Menu.Button
          onClick={() => handleMenuClick(category.id)}
          className="w-full text-black-300 font-bold text-xl hover:bg-blue-700 hover:text-white py-2 rounded-md"
        >
          {category.category_name}
          <ChevronDownIcon
            className="ml-1 h-5 w-5 inline"
            aria-hidden="true"
          />
        </Menu.Button>
        <Transition
          show={openMenus[category.id] || false}
          enter="transition duration-100 ease-out"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition duration-75 ease-out"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute left-0 mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
            <div className="py-1">
              {subCategories[category.id]?.map((subCategory) => (
                <Menu.Item key={subCategory.sub_id}>
                  {({ active }) => (
                    <button
                      onClick={() => handleSubcategoryClick(subCategory.sub_id)} // handle subcategory click
                      className={`block w-full text-left px-4 py-2 text-lg ${
                        active ? "bg-gray-100" : "text-gray-700"
                      }`}
                    >
                      {subCategory.sub_category_name}
                    </button>
                  )}
                </Menu.Item>
              ))}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    ))}
  </div>
</header>

        <main>
          <div >
            {children}
          </div>
        </main>
      </div>
    </nav>
      </>
  );

};
export default Navbar;